export default __webpack_public_path__ + "assets/fonts/9e40af7888dd783faf958303f55fff7c.woff";